import http from '../_http_v2';

const action = {
  //user
  userList: (m) => { return http.post(`console/log/action/user/list`, m); },
  userDetail: (m) => { return http.get(`console/log/action/user/${m.id}`); },

  //admin
  adminList: (m) => { return http.post(`console/log/action/admin/list`, m); },
  adminDetail: (m) => { return http.get(`console/log/action/admin/${m.id}`); },

  //partner
  partnerList: (m) => { return http.post(`console/log/action/partner/list`, m); },
  partnerDetail: (m) => { return http.get(`console/log/action/partner/${m.id}`); },
}

export default action

export { action }